import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoadingScreen } from '@/components/ui/LoadingSpinner';
import { useLogout } from '@/hooks/useApi';

const ApiKeys = React.lazy(() => import('@/pages/admin/ApiKeys'));

/** The whole app for a user whose only role is 'integration' (an external partner): their own API keys and
 *  sign-out, nothing else. The server enforces the same (app/auth/integration.py); this just avoids showing
 *  pages that would only answer 403. */
export function isIntegrationOnly(roles: string[] | undefined): boolean {
  return !!roles && roles.length > 0 && roles.every((r) => r === 'integration');
}

export default function IntegrationShell({ email }: { email?: string }) {
  const logout = useLogout();
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
          <span className="font-semibold text-gray-900">MatchPoint · API keys</span>
          <div className="flex items-center gap-3 text-sm text-gray-600 min-w-0">
            <span className="truncate">{email}</span>
            <button className="btn-secondary" onClick={() => logout.mutate()} disabled={logout.isPending}>
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 py-6">
        <React.Suspense fallback={<LoadingScreen message="Loading page..." />}>
          <Routes>
            <Route path="/admin/api-keys" element={<ApiKeys integrationMode />} />
            <Route path="*" element={<Navigate to="/admin/api-keys" replace />} />
          </Routes>
        </React.Suspense>
      </main>
    </div>
  );
}
